<template></template>

<script>
export default {
  name: "index",
  created() {
    this.$router.push("/home");
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Pages/index.vue